// @ts-strict-ignore
import { JsonObject, JsonProperty } from '@shared/convert/convert-core';

@JsonObject('SearchResultVO')
export class SearchResultVO {

  public static readonly CLASS_NAME: string = 'SearchResultVO';

  /**
	 * count of all elements matching search criteria independent from any
	 * given pagination
	 */
  @JsonProperty('count', 'Number')
  public count: number = undefined;

  @JsonProperty('type', 'String')
  public type: string = undefined;

  public constructor() {
    this.type = SearchResultVO.CLASS_NAME;
  }
}
